/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtClosePosition = {
  pool: Address;
  owner: Address;
  position: Address;
  positionNftMint: Address;
};

export type EvtClosePositionArgs = EvtClosePosition;

export function getEvtClosePositionEncoder(): FixedSizeEncoder<EvtClosePositionArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["positionNftMint", getAddressEncoder()],
  ]);
}

export function getEvtClosePositionDecoder(): FixedSizeDecoder<EvtClosePosition> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["positionNftMint", getAddressDecoder()],
  ]);
}

export function getEvtClosePositionCodec(): FixedSizeCodec<
  EvtClosePositionArgs,
  EvtClosePosition
> {
  return combineCodec(
    getEvtClosePositionEncoder(),
    getEvtClosePositionDecoder(),
  );
}
